import { render, staticRenderFns } from "./Manufacturers.vue?vue&type=template&id=7df65250"
import script from "./Manufacturers.vue?vue&type=script&lang=js"
export * from "./Manufacturers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports